app.config(function ($translateProvider) {
    $translateProvider.translations('nl', {
        CLEAR_ALL: 'Leegmaken filters',
        CLEAR: 'Leegmaken',
        ADVANCED_FILTERS: 'Geavanceerde Filters',
        VIEW_COLUMNS: 'Bekijk kolommen'
    });
});
